import React from 'react';
import styled from 'styled-components';

import { Icon } from './_base';

const FacebookSVG = styled(Icon).attrs({ viewBox: '0 0 22 40' })`
    width: 0.55em;
`;

function FacebookIcon({ color = 'currentColor', ...props }) {
    return (
        <FacebookSVG
            data-test="icon-facebook"
            {...props}
        >
            <path
                d="M0.4,13.4l5.5,0L6,9c0-1.8,0-4.6,1.4-6.4C8.7,0.7,10.6,0,13.9,0c5.4,0,7.6,0.8,7.6,0.8l-1.1,5.8c0,0-2-0.5-3.6-0.5c-1.7,0-3.1,0.6-3.1,2.2l0,5.1h6.6l-0.1,6.6L13.7,20v19.9L6.3,40V20.1H0.4V13.4z"
                fill={color}
            />
        </FacebookSVG>
    );
}

export {
    FacebookIcon as default,
    FacebookIcon,
};
